import { track } from '@amplitude/analytics-browser';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { storeConfigurationService } from 'commons/services';
import { StoreConfigurations } from 'commons/services/storeConfigurations/dtos';
import { QueryKeys } from '../enums/QueryKeys.enum';
import { TagKeys } from '../enums/TagKeys.enum';

export type UseGetStoreConfigurationsOptions = {
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
  cacheTime?: number;
};

export const useGetStoreConfigurations = (
  options?: UseGetStoreConfigurationsOptions,
): UseQueryResult<StoreConfigurations> & { retryWithTracking: () => void } => {
  const storeConfigurationsQuery = useQuery(
    [QueryKeys.StoreConfigurations],
    () => storeConfigurationService.fetchStoreConfigurations(),
    {
      refetchOnWindowFocus: options?.refetchOnWindowFocus ?? true,
      cacheTime: options?.cacheTime ?? 0,
      ...options,
    },
  );

  const retryWithTracking = () => {
    track(TagKeys.SettingsRetryClick);
    storeConfigurationsQuery.refetch();
  };

  return {
    ...(storeConfigurationsQuery as UseQueryResult<StoreConfigurations>),
    retryWithTracking,
  };
};
